export const BellIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4764 20.6197C10.9944 21.1967 11.6594 21.5137 12.3494 21.5137H12.3504C13.0434 21.5137 13.7114 21.1967 14.2304 20.6187C14.3635 20.4708 14.5499 20.3819 14.7486 20.3715C14.9473 20.3611 15.142 20.43 15.2899 20.5632C15.4377 20.6963 15.5266 20.8827 15.537 21.0814C15.5474 21.2801 15.4785 21.4748 15.3454 21.6227C14.5374 22.5197 13.4754 23.0137 12.3504 23.0137H12.3484C11.2284 23.0127 10.1664 22.5187 9.36136 21.6217C9.29557 21.5485 9.24484 21.463 9.21207 21.3702C9.1793 21.2774 9.16514 21.179 9.17038 21.0807C9.17563 20.9824 9.20019 20.8861 9.24265 20.7973C9.28511 20.7085 9.34465 20.629 9.41786 20.5632C9.49107 20.4974 9.57652 20.4467 9.66934 20.4139C9.76216 20.3811 9.86052 20.367 9.95881 20.3722C10.0571 20.3774 10.1534 20.402 10.2422 20.4445C10.331 20.4869 10.4106 20.5465 10.4764 20.6197ZM12.3994 1.51367C16.8444 1.51367 19.8304 4.97567 19.8304 8.20867C19.8304 9.87167 20.2534 10.5767 20.7024 11.3247C21.1464 12.0627 21.6494 12.9007 21.6494 14.4847C21.3004 18.5317 17.0754 18.8617 12.3994 18.8617C7.72336 18.8617 3.49736 18.5317 3.15236 14.5487C3.14936 12.9007 3.65236 12.0627 4.09636 11.3247L4.25336 11.0607C4.63936 10.3977 4.96836 9.67567 4.96836 8.20867C4.96836 4.97567 7.95436 1.51367 12.3994 1.51367ZM12.3994 3.01367C8.90436 3.01367 6.46936 5.75167 6.46936 8.20867C6.46936 10.2877 5.89136 11.2487 5.38136 12.0967C4.97236 12.7777 4.64936 13.3157 4.64936 14.4847C4.81636 16.3707 6.06136 17.3617 12.3994 17.3617C18.7024 17.3617 19.9864 16.3267 20.1524 14.4197C20.1494 13.3157 19.8264 12.7777 19.4174 12.0967C18.9074 11.2487 18.3304 10.2877 18.3304 8.20867C18.3304 5.75167 15.8944 3.01367 12.4004 3.01367H12.3994Z"
        fill="#141736"
      />
    </svg>
  );
};

export function TriangleIcon() {
  return (
    <svg
      width="32"
      height="39"
      viewBox="0 0 32 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.634669"
        width="23.6334"
        height="23.6334"
        transform="matrix(0.634669 -0.772784 0.634669 0.772784 0.677177 19.5266)"
        fill="white"
        stroke=""
      />
    </svg>
  );
}

export const UsersIcon = () => {
  return (
    <svg
      width="35"
      height="27"
      viewBox="0 0 33 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.587821"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41016 5.78841C7.41016 8.73393 9.79797 11.1217 12.7435 11.1217C15.689 11.1217 18.0768 8.73393 18.0768 5.78841C18.0768 2.84289 15.689 0.455078 12.7435 0.455078C9.79797 0.455078 7.41016 2.84289 7.41016 5.78841ZM20.7422 11.1221C20.7422 13.3312 22.533 15.1221 24.7422 15.1221C26.9513 15.1221 28.7422 13.3312 28.7422 11.1221C28.7422 8.91293 26.9513 7.12207 24.7422 7.12207C22.533 7.12207 20.7422 8.91293 20.7422 11.1221Z"
        fill="#8280FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.72 13.7881C6.42474 13.7881 1.25987 17.0234 0.743056 23.387C0.714905 23.7337 1.3778 24.4548 1.71219 24.4548H23.7378C24.7394 24.4548 24.755 23.6487 24.7394 23.3881C24.3487 16.8457 19.1038 13.7881 12.72 13.7881ZM32.0181 24.4551H26.8776C26.8775 21.4538 25.8858 18.6842 24.2123 16.4559C28.7541 16.5057 32.4624 18.8021 32.7415 23.6551C32.7527 23.8506 32.7415 24.4551 32.0181 24.4551Z"
        fill="#8280FF"
      />
    </svg>
  );
};

export const BoxIcon = () => {
  return (
    <svg
      width="31"
      height="34"
      viewBox="0 0 31 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.585938 11.7715L13.4864 19.2196C13.6253 19.2998 13.771 19.3577 13.9193 19.3945V33.8397L1.506 26.4935C0.935721 26.156 0.585938 25.5426 0.585938 24.8799V11.7715ZM30.5872 11.5732V24.8797C30.5872 25.5423 30.2375 26.1558 29.6672 26.4933L17.2539 33.8395V19.2677C17.2842 19.2526 17.3141 19.2365 17.3438 19.2193L30.5872 11.5732Z"
        fill="#FEC53D"
      />
      <path
        opacity="0.499209"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.992188 8.1565C1.14976 7.95752 1.34865 7.78934 1.58053 7.66584L14.7055 0.675178C15.2565 0.381712 15.9174 0.381712 16.4684 0.675178L29.5934 7.66584C29.7721 7.76104 29.9313 7.88279 30.067 8.02474L15.6769 16.3329C15.5822 16.3875 15.495 16.45 15.4155 16.5191C15.336 16.45 15.2487 16.3875 15.1541 16.3329L0.992188 8.1565Z"
        fill="#FEC53D"
      />
    </svg>
  );
};

export const GraphIcon = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.74002 25.344H27.0734C27.9325 25.344 28.6289 26.0404 28.6289 26.8995C28.6289 27.7586 27.9325 28.4551 27.0734 28.4551H2.18446C1.32535 28.4551 0.628906 27.7586 0.628906 26.8995V2.01063C0.628906 1.15152 1.32535 0.455078 2.18446 0.455078C3.04357 0.455078 3.74002 1.15152 3.74002 2.01063V25.344Z"
        fill="#4AD991"
      />
      <path
        opacity="0.5"
        d="M9.54196 18.6301C8.95438 19.2568 7.96997 19.2886 7.34321 18.701C6.71646 18.1134 6.68471 17.129 7.27229 16.5022L13.1056 10.28C13.6739 9.67387 14.6182 9.6213 15.2502 10.1606L19.8542 14.0894L25.8529 6.49114C26.3852 5.81684 27.3634 5.70176 28.0377 6.2341C28.712 6.76645 28.8271 7.74462 28.2947 8.41892L21.2947 17.2856C20.748 17.9781 19.7353 18.0778 19.064 17.505L14.36 13.4908L9.54196 18.6301Z"
        fill="#4AD991"
      />
    </svg>
  );
};

export function SettingIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="4 4 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41016 24.3317V22.0853C7.41016 20.8937 7.88351 19.7509 8.72609 18.9083C9.56867 18.0658 10.7114 17.5924 11.903 17.5924H16.3959C17.5875 17.5924 18.7303 18.0658 19.5729 18.9083C20.4154 19.7509 20.8888 20.8937 20.8888 22.0853V24.3317M9.6566 8.60665C9.6566 9.79823 10.13 10.941 10.9725 11.7836C11.8151 12.6262 12.9579 13.0995 14.1495 13.0995C15.3411 13.0995 16.4838 12.6262 17.3264 11.7836C18.169 10.941 18.6424 9.79823 18.6424 8.60665C18.6424 7.41506 18.169 6.27228 17.3264 5.4297C16.4838 4.58712 15.3411 4.11377 14.1495 4.11377C12.9579 4.11377 11.8151 4.58712 10.9725 5.4297C10.13 6.27228 9.6566 7.41506 9.6566 8.60665Z"
        stroke="#4D56FF"
        strokeWidth="1.26362"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LogoutIcon() {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.93359 11.7788H21.8503M21.8503 11.7788L17.9753 7.90381M21.8503 11.7788L17.9753 15.6538"
        stroke="white"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.18359 11.7787C1.18359 6.07171 5.80999 1.44531 11.5169 1.44531M11.5169 22.112C8.25369 22.112 5.34373 20.5993 3.44999 18.237"
        stroke="white"
        strokeWidth="1.9375"
        strokeLinecap="round"
      />
    </svg>
  );
}

// MARK: MENU ICONS
export function MenuSettingIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_710_3168)">
        <path
          d="M19.0222 11.962L18.2074 11.2913C17.6493 10.8318 17.6503 9.97783 18.2075 9.51928L19.0222 8.84854C19.6021 8.37117 19.7504 7.55261 19.3749 6.90211L17.766 4.11547C17.3904 3.465 16.6072 3.18422 15.904 3.44764L14.9157 3.8179C14.2388 4.07144 13.4997 3.6438 13.3811 2.9319L13.2076 1.89086C13.0842 1.15004 12.4494 0.612305 11.6983 0.612305H8.48061C7.7295 0.612305 7.09472 1.15004 6.97127 1.8909L6.79775 2.9319C6.6789 3.64506 5.93884 4.07102 5.26316 3.81793L4.27488 3.44764C3.57166 3.18422 2.78853 3.46504 2.41291 4.11547L0.804073 6.90207C0.428536 7.5525 0.576807 8.37109 1.1567 8.8485L1.97146 9.51924C2.52966 9.97874 2.52855 10.8326 1.97146 11.2912L1.15666 11.962C0.576807 12.4394 0.428497 13.258 0.804035 13.9084L2.41291 16.695C2.78849 17.3455 3.57147 17.6263 4.27488 17.3629L5.26313 16.9926C5.94018 16.739 6.67909 17.1669 6.79771 17.8786L6.97123 18.9196C7.09472 19.6605 7.7295 20.1982 8.48058 20.1982H11.6983C12.4494 20.1982 13.0842 19.6605 13.2076 18.9196L13.3811 17.8787C13.4999 17.1657 14.2399 16.7395 14.9157 16.9927L15.904 17.3629C16.6074 17.6264 17.3904 17.3455 17.766 16.6951L19.3749 13.9084C19.7504 13.258 19.6021 12.4394 19.0222 11.962ZM16.4408 15.93L15.4526 15.5597C13.8727 14.9679 12.1486 15.9664 11.8718 17.6271L11.6983 18.6681H8.48061L8.30709 17.6271C8.02979 15.9632 6.30313 14.9691 4.72635 15.5597L3.73806 15.93L2.12922 13.1434L2.94399 12.4726C4.24649 11.4004 4.24378 9.40796 2.94399 8.33792L2.12922 7.66718L3.7381 4.88055L4.72635 5.25081C6.30623 5.84259 8.03033 4.84417 8.30709 3.18346L8.48058 2.14246H11.6983L11.8718 3.18346C12.1491 4.84757 13.8759 5.84137 15.4525 5.25081L16.4408 4.88055L18.05 7.6668C18.05 7.6668 18.0499 7.66691 18.0496 7.66714L17.2349 8.33789C15.9324 9.41006 15.935 11.4025 17.2348 12.4726L18.0496 13.1433L16.4408 15.93ZM10.0895 6.63089C8.00826 6.63089 6.31507 8.32408 6.31507 10.4053C6.31507 12.4865 8.00826 14.1797 10.0895 14.1797C12.1707 14.1797 13.8638 12.4865 13.8638 10.4053C13.8638 8.32408 12.1707 6.63089 10.0895 6.63089ZM10.0895 12.6495C8.85198 12.6495 7.84522 11.6427 7.84522 10.4053C7.84522 9.1678 8.85198 8.16104 10.0895 8.16104C11.3269 8.16104 12.3337 9.1678 12.3337 10.4053C12.3337 11.6427 11.3269 12.6495 10.0895 12.6495Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_710_3168">
          <rect
            width="19.5859"
            height="19.5859"
            fill="white"
            transform="translate(0.296875 0.612305)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MenuHistoryIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0906 8.61237V12.6124L14.0906 14.6124M3.14062 11.6124C3.36472 9.41243 4.39089 7.37199 6.02336 5.88034C7.65583 4.38869 9.78032 3.55026 11.9915 3.525C14.2027 3.49975 16.3458 4.28944 18.0119 5.74341C19.678 7.19738 20.7505 9.21385 21.0248 11.4081C21.2991 13.6024 20.7559 15.8208 19.499 17.6401C18.242 19.4595 16.3593 20.7524 14.2099 21.2722C12.0605 21.792 9.79504 21.5024 7.84562 20.4584C5.89621 19.4145 4.39935 17.6895 3.64062 15.6124M3.14062 20.6124V15.6124H8.14062"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuChatIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25056 12.291L19.2506 1.29102M8.25056 12.291L11.7506 19.291C11.7944 19.3868 11.8649 19.4679 11.9535 19.5248C12.0421 19.5816 12.1452 19.6119 12.2506 19.6119C12.3559 19.6119 12.459 19.5816 12.5476 19.5248C12.6362 19.4679 12.7067 19.3868 12.7506 19.291L19.2506 1.29102M8.25056 12.291L1.25056 8.79102C1.15482 8.74714 1.07369 8.6767 1.0168 8.58807C0.959924 8.49943 0.929688 8.39633 0.929688 8.29102C0.929687 8.1857 0.959924 8.0826 1.0168 7.99396C1.07369 7.90533 1.15482 7.83489 1.25056 7.79102L19.2506 1.29102"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuDriversIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0918 1.13906C5.13196 1.13906 0.283594 5.98743 0.283594 11.9472C0.283594 17.9071 5.13196 22.7554 11.0918 22.7554C17.0516 22.7554 21.9 17.907 21.9 11.9472C21.9 5.98748 17.0516 1.13906 11.0918 1.13906ZM11.0918 21.8284C5.64338 21.8284 1.21058 17.3956 1.21058 11.9472C1.21058 6.4989 5.64338 2.06604 11.0918 2.06604C16.5402 2.06604 20.973 6.49885 20.973 11.9472C20.973 17.3956 16.5402 21.8284 11.0918 21.8284Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M13.0826 12.3969C13.0826 11.2978 12.1885 10.4037 11.0893 10.4037C9.99014 10.4037 9.09609 11.2978 9.09609 12.3969C9.09609 13.4962 9.9901 14.3902 11.0893 14.3902C12.1885 14.3902 13.0826 13.4962 13.0826 12.3969ZM11.0893 13.6622C10.3919 13.6622 9.82415 13.0944 9.82415 12.3969C9.82415 11.6994 10.3918 11.1318 11.0893 11.1318C11.7868 11.1318 12.3545 11.6994 12.3545 12.3969C12.3545 13.0944 11.7868 13.6622 11.0893 13.6622Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M18.3902 13.479L18.3899 13.4789C16.5049 12.9759 14.4774 13.519 13.0991 14.8973C11.913 16.0834 11.341 17.7211 11.5301 19.3893L11.5334 19.3891L11.5301 19.3895C11.5547 19.6044 11.7368 19.7634 11.9485 19.7634C11.9649 19.7634 11.981 19.7624 11.9965 19.7606L11.9968 19.7606C13.5732 19.5798 15.0421 18.9327 16.2442 17.8896C17.435 16.8564 18.2802 15.5097 18.6876 13.9954C18.7481 13.7706 18.6149 13.5395 18.3902 13.479ZM13.6952 15.4933L13.6952 15.4933C14.7574 14.431 16.2763 13.9551 17.7447 14.2011C17.3464 15.3795 16.643 16.4277 15.6918 17.253C14.7304 18.0871 13.5789 18.6371 12.3386 18.8589C12.3129 17.6007 12.7947 16.3938 13.6952 15.4933Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M3.80355 13.4769C3.80148 13.4774 3.79879 13.478 3.79563 13.4788C3.79537 13.4789 3.79511 13.479 3.79484 13.479L3.79422 13.4792C3.7947 13.4791 3.79517 13.4789 3.79563 13.4788C3.79869 13.478 3.80131 13.4774 3.80335 13.477L3.80355 13.4769ZM3.80355 13.4769L3.80371 13.4769C3.80366 13.4769 3.80361 13.4769 3.80355 13.4769ZM3.79563 13.4788L3.7811 13.4827L3.77962 13.4834C3.56409 13.55 3.43825 13.7759 3.49736 13.9955L3.49736 13.9955C3.9048 15.5098 4.74996 16.8565 5.9408 17.8898L6.03911 17.7765L5.94081 17.8898C7.14289 18.9328 8.61181 19.5799 10.1881 19.7607L10.1885 19.7608C10.204 19.7625 10.2201 19.7635 10.2365 19.7635C10.4424 19.7635 10.6206 19.6132 10.6526 19.4068L10.6532 19.4052L10.6549 19.39L10.6549 19.3895C10.655 19.3887 10.6551 19.3879 10.6552 19.3872L10.6559 19.3815V19.3814C10.8422 17.716 10.2701 16.0816 9.08595 14.8975C7.70762 13.5191 5.68082 12.9757 3.79563 13.4788ZM3.80778 13.4761C3.80898 13.4759 3.80966 13.4758 3.80939 13.4759L3.80936 13.4759L3.80928 13.4759L3.80899 13.4759L3.80784 13.4761L3.80778 13.4761ZM6.49321 17.2531L6.4932 17.2531C5.54201 16.4278 4.83857 15.3795 4.44029 14.2011C5.90866 13.9552 7.42757 14.4311 8.48988 15.4934C9.39027 16.3938 9.8721 17.6008 9.84641 18.8589C8.60609 18.6372 7.45453 18.0872 6.49321 17.2531Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M18.9568 11.8317C18.9273 9.75536 18.0959 7.80729 16.6165 6.34762C15.1356 4.88642 13.1735 4.08145 11.0929 4.08145C9.01239 4.08145 7.05034 4.88642 5.56937 6.34761L5.67472 6.45439L5.56937 6.34761C4.08995 7.8073 3.25856 9.75536 3.22895 11.8317L3.22895 11.8318L18.326 12.0105L18.2103 12.1059C18.3242 12.2441 18.5128 12.2949 18.6806 12.2334L18.6807 12.2333C18.8487 12.1717 18.9594 12.0107 18.9568 11.8317ZM18.9568 11.8317L18.8068 11.8338L18.9568 11.8316C18.9568 11.8317 18.9568 11.8317 18.9568 11.8317ZM3.50494 12.2333C3.55254 12.2509 3.60175 12.2592 3.6503 12.2592C3.77351 12.2592 3.89376 12.2051 3.9755 12.1059L3.50494 12.2333ZM3.50494 12.2333L3.55676 12.0927L3.50508 12.2334C3.50503 12.2334 3.50499 12.2333 3.50494 12.2333ZM16.0245 6.94763L16.1298 6.84086L16.0245 6.94763C17.0641 7.9734 17.7449 9.26805 18.0009 10.6763C16.2352 9.09647 13.7382 8.18461 11.0929 8.18461C8.44764 8.18461 5.95063 9.09646 4.18507 10.6763C4.44105 9.26804 5.12181 7.97339 6.16143 6.94763C7.48396 5.64273 9.2349 4.92437 11.093 4.92437C12.9511 4.92437 14.702 5.64273 16.0245 6.94763Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function MenuRoutesIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.07796 3.76784L1.07791 3.76748C0.912839 2.40684 1.82157 1.12337 3.16497 0.833205C4.59269 0.523096 5.97964 1.41163 6.32698 2.79209H15.3245C17.5317 2.79209 19.3459 4.52864 19.3459 6.68013C19.3459 8.83146 17.5359 10.5682 15.3245 10.5682H5.89385C4.38355 10.5682 3.17683 11.7365 3.17683 13.1478C3.17683 14.5591 4.38355 15.7274 5.89385 15.7274H11.859L10.5516 14.4201L10.547 14.4154L10.547 14.4154C10.3059 14.1613 10.3059 13.7634 10.547 13.5093L10.5493 13.5069L10.5493 13.5069C10.7999 13.2497 11.2112 13.2458 11.4705 13.4921L11.4753 13.4966L11.4753 13.4967L13.8964 15.9219L1.07796 3.76784ZM1.07796 3.76784C1.26521 5.29264 2.68317 6.33552 4.18061 6.08597L4.18157 6.0858M1.07796 3.76784L4.18157 6.0858M4.18157 6.0858C5.23451 5.90612 6.07216 5.12313 6.33079 4.10057M4.18157 6.0858L6.33079 4.10057M6.33079 4.10057H15.3285C16.8345 4.10057 18.0415 5.26867 18.0415 6.68017C18.0415 8.09164 16.8346 9.25978 15.3285 9.25978H5.89385C3.68279 9.25978 1.86835 10.9962 1.86835 13.1478C1.86835 15.2993 3.68258 17.0359 5.88979 17.0359H11.8559L10.5535 18.3413C10.2931 18.5915 10.2868 19.01 10.5435 19.2667C10.7922 19.5154 11.2053 19.5366 11.467 19.2749C11.467 19.2748 11.467 19.2748 11.4671 19.2748L11.4726 19.2693L11.4745 19.2674L11.475 19.2669L11.4751 19.2668L11.4751 19.2667L11.4752 19.2667L13.8964 16.8454C14.1517 16.5902 14.1517 16.1774 13.8966 15.9221L6.33079 4.10057ZM3.73527 4.80919C2.98001 4.80919 2.36835 4.19756 2.36835 3.44227C2.36835 2.68701 2.97998 2.07535 3.73527 2.07535C4.49054 2.07535 5.1022 2.68698 5.1022 3.44227C5.1022 4.19753 4.49053 4.80919 3.73527 4.80919Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M19.4805 12.7871C17.6121 12.7871 16.0938 14.3055 16.0938 16.1738C16.0938 18.0422 17.6121 19.5605 19.4805 19.5605C21.3488 19.5605 22.8672 18.0422 22.8672 16.1738C22.8672 14.3055 21.3545 12.7928 19.4805 12.7871ZM19.4805 18.4317C18.233 18.4317 17.2226 17.4213 17.2226 16.1738C17.2226 14.9264 18.233 13.916 19.4805 13.916C20.7279 13.916 21.7383 14.9264 21.7383 16.1738C21.7383 17.4213 20.7279 18.4317 19.4805 18.4317Z"
        fill="white"
      />
    </svg>
  );
}

export function MenuHomeIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.32984 2.29102H5.42984C3.23984 2.29102 2.08984 3.44102 2.08984 5.62102V7.52102C2.08984 9.70102 3.23984 10.851 5.41984 10.851H7.31984C9.49984 10.851 10.6498 9.70102 10.6498 7.52102V5.62102C10.6598 3.44102 9.50984 2.29102 7.32984 2.29102Z"
        fill="white"
      />
      <path
        opacity="0.6"
        d="M18.7613 2.29102H16.8613C14.6813 2.29102 13.5312 3.44102 13.5312 5.62102V7.52102C13.5312 9.70102 14.6813 10.851 16.8613 10.851H18.7613C20.9413 10.851 22.0913 9.70102 22.0913 7.52102V5.62102C22.0913 3.44102 20.9413 2.29102 18.7613 2.29102Z"
        fill="white"
      />
      <path
        d="M18.7613 13.7207H16.8613C14.6813 13.7207 13.5312 14.8707 13.5312 17.0507V18.9507C13.5312 21.1307 14.6813 22.2807 16.8613 22.2807H18.7613C20.9413 22.2807 22.0913 21.1307 22.0913 18.9507V17.0507C22.0913 14.8707 20.9413 13.7207 18.7613 13.7207Z"
        fill="white"
      />
      <path
        opacity="0.6"
        d="M7.32984 13.7207H5.42984C3.23984 13.7207 2.08984 14.8707 2.08984 17.0507V18.9507C2.08984 21.1407 3.23984 22.2907 5.41984 22.2907H7.31984C9.49984 22.2907 10.6498 21.1407 10.6498 18.9607V17.0607C10.6598 14.8707 9.50984 13.7207 7.32984 13.7207Z"
        fill="white"
      />
    </svg>
  );
}

export function EditProfileIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3513 12.9574C11.1626 13.146 10.9295 13.29 10.6768 13.3742L8.23631 14.1875C8.06018 14.2462 7.87649 14.2761 7.69065 14.2761C7.22967 14.2761 6.7963 14.0966 6.47039 13.7707C6.00519 13.3055 5.84551 12.6291 6.05354 12.0052L6.86706 9.56535C6.95123 9.31265 7.09542 9.0794 7.2839 8.89096L12.555 3.62109H2.24195C1.07897 3.62109 0.132812 4.56704 0.132812 5.72975V17.9983C0.132812 19.161 1.07897 20.1069 2.24195 20.1069H14.5133C15.6763 20.1069 16.6224 19.161 16.6224 17.9983V7.68757L11.3513 12.9574Z"
        fill="black"
      />
      <path
        d="M8.09918 9.70461C8.03602 9.76776 7.98847 9.8447 7.96024 9.92939L7.14673 12.3693C7.07782 12.5759 7.13162 12.8037 7.28566 12.9578C7.43975 13.1118 7.66761 13.1656 7.8743 13.0967L10.3148 12.2834C10.3995 12.2552 10.4764 12.2076 10.5396 12.1445L17.7254 4.96037L15.285 2.52051L8.09918 9.70461Z"
        fill="black"
      />
      <path
        d="M18.3986 0.758268C18.0242 0.383963 17.4172 0.383963 17.0428 0.758268L16.0938 1.70712L18.5342 4.14703L19.4833 3.19817C19.8577 2.82387 19.8577 2.217 19.4833 1.84269L18.3986 0.758268Z"
        fill="black"
      />
    </svg>
  );
}

export function CameraIcon() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7174 10.0588C8.91399 10.0588 9.88402 9.0888 9.88402 7.89221C9.88402 6.69561 8.91399 5.72559 7.7174 5.72559C6.52081 5.72559 5.55078 6.69561 5.55078 7.89221C5.55078 9.0888 6.52081 10.0588 7.7174 10.0588Z"
        stroke="white"
      />
      <path
        d="M6.11342 13.6697H9.32291C11.5769 13.6697 12.7043 13.6697 13.5139 13.1389C13.8632 12.9099 14.1641 12.6144 14.3993 12.2693C14.9402 11.4749 14.9402 10.3677 14.9402 8.15491C14.9402 5.94134 14.9402 4.83492 14.3993 4.04049C14.1641 3.69536 13.8632 3.3999 13.5139 3.17096C12.9939 2.82935 12.3425 2.7073 11.3451 2.66397C10.8692 2.66397 10.4597 2.31009 10.3665 1.85149C10.2953 1.51556 10.1103 1.21453 9.84279 0.999246C9.57527 0.783967 9.24162 0.667651 8.89825 0.669955H6.53808C5.82454 0.669955 5.20994 1.16467 5.06983 1.85149C4.97667 2.31009 4.56717 2.66397 4.09124 2.66397C3.09459 2.7073 2.44316 2.83008 1.92245 3.17096C1.57335 3.39994 1.27274 3.69541 1.03775 4.04049C0.496094 4.83492 0.496094 5.94134 0.496094 8.15491C0.496094 10.3677 0.496094 11.4742 1.03703 12.2693C1.27102 12.6131 1.57146 12.9085 1.92245 13.1389C2.73205 13.6697 3.85941 13.6697 6.11342 13.6697Z"
        stroke="white"
      />
      <path d="M12.773 5.72559H12.0508" stroke="white" strokeLinecap="round" />
    </svg>
  );
}
